import { ReactNode } from 'react'

/** Footer row under an assistant answer: citations, hand-off links, badges. */
const MetaRow = ({ children }: { children: ReactNode }) => (
  <div className="mt-[11px] flex flex-wrap items-center gap-3">{children}</div>
)

export default MetaRow
